import type { DeferredSpawn } from '../types';
import { registerWeapon, lookupWeapon, createProjectile } from './registry';
import { SMALL_CRATER, DEFAULT_CRATER } from '../terrain/crater-shapes';
import { random } from '../terrain/rng';

const METEOR_SHOWER = registerWeapon({
  id: 'meteor_shower',
  name: 'Meteor Shower',
  description: 'Impact marks a zone. 5 meteors rain from the sky after a delay.',
  tier: 'EPIC',
  rarity: 'epic',
  projectileRadius: 8,
  projectileSpeed: 0.50,
  color: 0xff4400,
  gravity: 0.15,
  bounces: 0,
  bounceEnergyRetention: 0.85,
  damage: 15,
  blastRadius: 50,
  knockbackMult: 0.04,
  knockbackRadius: 1.0,
  shakeIntensity: 4.0,
  particleScale: 0.8,
  craterShape: SMALL_CRATER,
  canDestroyWireframe: true,
  wireframeDamageScale: 0.6,
  onImpact(proj, x, y, _hitType, _hitIndex, state, _fx) {
    const spawns: DeferredSpawn[] = [];
    const meteorWeapon = lookupWeapon('meteor');
    for (let i = 0; i < 5; i++) {
      const mx = x + (i - 2) * 60 + (random() - 0.5) * 40;
      const delay = 60 + i * 12; // staggered by ~0.2s each
      spawns.push({
        spawnFrame: state.frameCount + delay,
        spawned: false,
        projectile: createProjectile(
          meteorWeapon, mx, -200,
          (random() - 0.5) * 2,
          8 + random() * 4,
          proj.owner, state.frameCount, 1,
        ),
      });
    }
    return spawns;
  },
});

// Meteor sub-weapon (not in lottery pool)
registerWeapon({
  id: 'meteor',
  name: 'Meteor',
  description: '',
  tier: 'SUB',
  rarity: 'common',
  projectileRadius: 7,
  projectileSpeed: 0.55,
  color: 0xff4400,
  gravity: 0.10,
  bounces: 0,
  bounceEnergyRetention: 0.85,
  damage: 28,
  blastRadius: 80,
  knockbackMult: 0.07,
  knockbackRadius: 1.2,
  shakeIntensity: 2.5,
  particleScale: 1.2,
  craterShape: DEFAULT_CRATER,
  canDestroyWireframe: true,
  wireframeDamageScale: 0.4,
});
